import { fetchUserTargets, userTargetsQueryKey, type UserTargets } from "@/packages/dashboard/api/user-targets";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { createContext, useContext, type ReactNode } from "react";

type UserTargetsContextValue = UseQueryResult<UserTargets, Error>;

const UserTargetsContext = createContext<UserTargetsContextValue | undefined>(undefined);

type UserTargetsProviderProps = {
  children: ReactNode;
};

export const UserTargetsProvider = ({ children }: UserTargetsProviderProps) => {
  const queryResult = useQuery<UserTargets, Error>({
    queryKey: userTargetsQueryKey,
    queryFn: fetchUserTargets,
    staleTime: 5 * 60 * 1000,
  });

  return <UserTargetsContext.Provider value={queryResult}>{children}</UserTargetsContext.Provider>;
};

export const useUserTargets = () => {
  const context = useContext(UserTargetsContext);

  if (!context) {
    throw new Error("useUserTargets must be used within a UserTargetsProvider");
  }

  return context;
};
